import React, { useEffect, useState } from "react";
import $ from "jquery";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Lenis from '@studio-freight/lenis'

import { LinkProvider } from './LinkProvider';

import { images } from "./imagesToLoad";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import TradingAssets from "./pages/TradingAssets";
import AccountTypes from "./pages/AccountTypes";
import Fees from "./pages/Fees";
import BonusSystem from "./pages/BonusSystem";
import AboutUs from "./pages/AboutUs";
import SpecialOffers from "./pages/SpecialOffers";

function App() {

    useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    return () => lenis.destroy()
  }, [])

  
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      };
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $("body").addClass("ovf-hidden");
    Promise.all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err);
        setIsLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    !isLoading && $("body").removeClass("ovf-hidden");
    !isLoading && $("#loader").addClass("hide");
  }, [isLoading]);

  if (isLoading) return <div id="loader">Loading...</div>;

  return (
    <div className="overflow-x-hidden">
      <LinkProvider>
        <Router>
          <Header />
          <AnimatedRoutes />
          <Footer />
        </Router>
      </LinkProvider>
    </div>
  );
}

// компонент для анимации переходов
function AnimatedRoutes() {
  const location = useLocation();

  const pageVariants = {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
  };

  const pageTransition = {
    duration: 0.5,
    ease: "easeInOut",
  };

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/trading"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <TradingAssets />
            </motion.div>
          }
        />
        <Route
          path="/account"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AccountTypes />
            </motion.div>
          }
        />
        <Route
          path="/fees"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Fees />
            </motion.div>
          }
        />
        <Route
          path="/education"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <BonusSystem />
            </motion.div>
          }
        />
        <Route
          path="/about"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AboutUs />
            </motion.div>
          }
        />
        <Route
          path="/offers"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
            >
              <SpecialOffers />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
